var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShipping(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.0992 15.5977L25.6632 12.9576C25.1836 12.6776 24.6641 12.5176 24.1446 12.5176H16.3915C15.8719 12.5176 15.3124 12.6776 14.8728 12.9576L10.3569 15.6777C9.67748 16.2377 9.27783 17.0778 9.27783 17.9578V28.5583C9.27783 30.1984 10.5967 31.5184 12.2352 31.5184H28.2609C29.8994 31.5184 31.2182 30.1984 31.2182 28.5583V17.9578C31.2582 17.0778 30.8586 16.2377 30.0992 15.5977ZM20.9074 13.8376H24.1446C24.4643 13.8376 24.744 13.9176 25.0238 14.0776L29.1401 16.5178H20.9074V13.8376ZM15.5522 14.0776C15.832 13.9176 16.1117 13.8376 16.4314 13.8376H19.6686V16.5178H11.4759L15.5522 14.0776ZM29.9394 28.5183C29.9394 29.4383 29.1801 30.1984 28.2609 30.1984H12.2752C11.356 30.1984 10.5967 29.4383 10.5967 28.5183V17.9578C10.5967 17.9178 10.5967 17.8378 10.5967 17.7978H29.9394C29.9394 17.8378 29.9394 17.9178 29.9394 17.9578V28.5183Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.572 9.99754C45.3251 22.9981 35.4939 40.1589 20.2675 39.9989C9.23732 39.9989 0.285316 31.0385 0.285316 19.998C0.125458 4.95731 16.8705 -4.88313 29.8989 2.5172C29.4593 2.75722 29.0596 3.03723 28.66 3.31724C16.4709 -3.00304 1.44428 6.23737 1.56417 20.038C1.56417 30.3585 9.95668 38.7588 20.2675 38.7588C34.3749 38.8788 43.5667 23.1581 36.6129 10.9976L37.572 9.99754Z",
    fill: "url(#paint1_linear)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.504 19.0777H28.6603V22.1979H24.504V19.0777ZM13.354 24.638H19.6284V23.3579H13.354V24.638ZM13.354 27.2381H19.6284V25.958H13.354V27.2381ZM35.8139 0.836914L34.8948 1.75696L36.9729 3.83705H34.8948C30.4987 3.83705 26.9419 7.39721 26.9419 11.7974H28.2607C28.2607 8.11724 31.258 5.15711 34.8948 5.15711H36.9729L34.8948 7.1972L35.8139 8.11724L39.4507 4.47708L35.8139 0.836914Z",
    fill: "url(#paint2_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 9.27783,
    y1: 31.5184,
    x2: 28.0834,
    y2: 9.80076,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 0.28418,
    y1: 40,
    x2: 40.2842,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB800"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 13.354,
    y1: 27.2381,
    x2: 39.7534,
    y2: 1.14316,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0083BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AB800"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipping);
export default __webpack_public_path__ + "static/media/shipping.1742f51b9c359eb2457f6e65d00def17.svg";
export { ForwardRef as ReactComponent };